import React, { useMemo } from 'react';
import PageHeader from '../../components/shared/PageHeader';
import { Card, StatusPill } from '../../components/shared/DataToolbar';
import { LoadingState, ErrorState, EmptyResults } from '../../components/shared/Pending';
import { useApi } from '../../api/useApi';
import { listUsers } from '../../api/adminApi';
import { Users2, ExternalLink } from 'lucide-react';

export default function AdminHosts() {
  const { data, loading, error, refetch } = useApi(() => listUsers({ type: 'host', per_page: 50 }), []);
  const hosts = useMemo(() => Array.isArray(data) ? data : (data?.items || data || []), [data]);

  return (
    <div>
      <PageHeader title="Hosts" description="Host accounts, subscriptions and payout readiness." />
      {loading ? <LoadingState /> : error ? <ErrorState error={error} onRetry={refetch} /> : hosts.length === 0 ? <EmptyResults icon={Users2} title="No hosts" description="Host accounts will appear here after registration or admin creation." /> : (
        <Card className="overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider"><tr><th className="text-left px-4 py-3 font-medium">Host</th><th className="text-left px-4 py-3 font-medium">Subscription</th><th className="text-left px-4 py-3 font-medium">Stripe Connect</th><th className="text-left px-4 py-3 font-medium">Public profile</th></tr></thead>
            <tbody className="divide-y divide-slate-100">
              {hosts.map((host) => (
                <tr key={host.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3"><div className="font-medium text-slate-900">{host.name}</div><div className="text-xs text-slate-500">{host.email}</div></td>
                  <td className="px-4 py-3"><div className="flex items-center gap-2"><span className="text-xs font-medium uppercase text-slate-600">{host.subscription?.plan || 'free'}</span><StatusPill status={host.subscription?.status || 'pending'} /></div></td>
                  <td className="px-4 py-3"><StatusPill status={host.stripe_connect?.active ? 'active' : (host.stripe_connect?.status || 'pending')} /></td>
                  <td className="px-4 py-3">{host.public_slug ? <a href={`https://v2.stayeasy.io/hosts/${host.id}/${host.public_slug}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-teal-700 hover:underline">View <ExternalLink className="h-3 w-3" /></a> : <span className="text-slate-400">Not configured</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
